import { ViewportScroller } from '@angular/common';
import { ApplicationRef, enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Router, Scroll } from '@angular/router';
import { Store } from '@ngxs/store';
import { VnextStorageLoggerService } from '@vnext/core/store/logger/vnext-storage-logger.service';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppConfigModel, AppConfigState } from 'vnext-shared';
import { DEFAULT_ROUTES, VIEWPORT_SCROLL_OFFSET } from './app/app-routing.config';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { RouteBuilder } from './app/core/routes/route-generator';

VnextStorageLoggerService.configure(environment.production);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef: ApplicationRef) => {
    const router = appRef.injector.get(Router);
    const store = appRef.injector.get(Store);
    const viewportScroller = appRef.injector.get(ViewportScroller);

    viewportScroller.setOffset(VIEWPORT_SCROLL_OFFSET);

    router.events.pipe(filter((event): event is Scroll => event instanceof Scroll)).subscribe({
      next: (event: Scroll) => {
        if (event?.anchor) {
          const scrollAnchor: string = event.anchor;
          setTimeout(() => {
            viewportScroller.scrollToAnchor(scrollAnchor);
          });
        }
      }
    });

    // rebuild routes if the config pages or homepage changes in live edit
    if (environment.liveedit) {
      store.select(AppConfigState.pages).subscribe({
        next: pages => {
          const homepage = store.selectSnapshot(AppConfigState.homepage);
          const defaultRoutes = [...DEFAULT_ROUTES];
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const appConfig = { pages, homepage } as AppConfigModel;
          defaultRoutes.unshift(
            ...RouteBuilder.build(appConfig, {
              disabledRoutes: []
            })
          );
          router.resetConfig(defaultRoutes);
        }
      });

      store.select(AppConfigState.homepage).subscribe({
        next: homepage => {
          const pages = store.selectSnapshot(AppConfigState.pages);
          const defaultRoutes = [...DEFAULT_ROUTES];
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const appConfig = { pages, homepage } as AppConfigModel;
          defaultRoutes.unshift(
            ...RouteBuilder.build(appConfig, {
              disabledRoutes: []
            })
          );
          router.resetConfig(defaultRoutes);
        }
      });
    }
  })
  .catch(err => {
    console.error(err);
  });
